import { z } from "zod";

import { eventTypeAppCardZod } from "@calcom/app-store/eventTypeAppCardZod";

// Per-event-type activation of the manual "Remind via WhatsApp" button (see
// specs/notif-whatsapp-gowa/design.md, section "Activation par event-type"). `enabled` here is
// independent from the account/team-level Credential (instanceUrl/basicAuth, see
// lib/gowaCredentialKeysSchema.ts) — it only controls whether the manual reminder button is shown
// on this event-type's bookings, not whether Gowa itself is configured for the team/user.
export const appDataSchema = eventTypeAppCardZod.merge(z.object({}));
export const appKeysSchema = z.object({});
